/**
 * Border and styling design tokens
 * Includes border radius, thickness, and effects
 */
export const BorderTokens = {
    // Border radius for rounded corners
    radius: {
        none: 0,
        sm: 4,
        md: 8,
        lg: 12,
        xl: 16,
        full: 9999, // For circular/pill shapes
    },

    // Border thickness
    width: {
        thin: 1,
        normal: 2,
        thick: 3,
        extraThick: 4,
    },

    // Glow/shadow effects (for outer glow simulation)
    glow: {
        none: 0,
        sm: 2,
        md: 4,
        lg: 6,
        xl: 8,
    },
};

/**
 * Text styling tokens for shadows and strokes
 */
export const TextStyleTokens = {
    // Text stroke (outline)
    stroke: {
        none: 0,
        thin: 1,
        normal: 2,
        thick: 3,
        extraThick: 4,
    },

    // Shadow offsets
    shadow: {
        x: 2,
        y: 2,
        blur: 4,
    },
};
